import { useState } from "react";

// An "11 + 1" saving scheme: the customer pays 11 monthly instalments and
// the jeweller adds the 12th. Totals are derived from the instalment and
// the months paid so far.
export function useSavingsScheme(initialAmount: number, initialMonths: number) {
  const initialState = { amount: initialAmount, months: initialMonths };
  const [state, setState] = useState(initialState);

  const setAmount = (value: string) => {
    const amount = parseFloat(value);
    setState((state) => ({
      ...state,
      amount: Number.isFinite(amount) && amount > 0 ? amount : 0,
    }));
  };
  const setMonths = (months: number) => setState((state) => ({ ...state, months }));

  return {
    ...state,
    setAmount,
    setMonths,
    customerPays: state.amount * 11,
    customerGets: state.amount * 12,
    paidSoFar: state.amount * Math.min(state.months, 11),
  };
}
